import React, { Component } from 'react';

class Author extends Component {
    constructor(props){
        super(props);
        this.state = {
            listItem: [
                {
                    id: 1,
                    icon: 'fa fa-check',
                    title: 'Liderazgo Transparente',
                },
                {
                    id: 2,
                    icon: 'fa fa-check',
                    title: 'Gestión Participativa',
                },
                {
                    id: 3,
                    icon: 'fa fa-check',
                    title: 'Educación Continua',
                },
            ]
        }
    }
    render() {
        return (
            <section className="author-section section-padding bg-white" id="author">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <div className="section-heading center-heading text-center mb-60">
                                <h3 className="heading-title">Transparencia y Eficiencia en la Gestión Pública</h3>
                                <p>Liderazgo con Visión y Valores</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-5 col-md-6">
                            <div className="auhtor-img mb-4 mb-lg-0">
                                {/* Foto reutilizada de la sección "Acerca de" (eliminada) */}
                                <img src="assets/images/banner/marlene-about.jpeg" alt="Marlene Puertas Ramírez" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-6 ps-4">
                            <div className="section-heading mb-0">
                                {/* Actualizado: "Marlene Puertas" → nombre completo */}
                                <h3 className="heading-title">Marlene Puertas Ramírez</h3>
                                {/* Actualizado: texto genérico → logro IMCO y cargo actual (Semblanza) */}
                                <p>Ha desempeñado cargos estratégicos en los tres órdenes de gobierno. Como Directora de Presupuesto y Contabilidad del Municipio de Pachuca de Soto (2016–2020), logró que el municipio pasara del lugar 89 al 7 nacional en el Índice de Información Presupuestal del IMCO. Actualmente es Regidora de Mineral de la Reforma, donde participa en la toma de decisiones del Cabildo y supervisa el ejercicio del gasto público.</p>
                            </div>

                            <div className="author-desc">
                                <ul className="list-unstyled">
                                    {
                                    this.state.listItem.map((data,i) => (
                                        <li key={data.id}><i className={data.icon}></i> {data.title}</li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section> 
        );
    }
}

export default Author;
